import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Calout } from "@/ui/Calout";
import { Modal, Title } from "@/ui/Modal";
import { TextInput } from "@/ui/TextInput";
import { TextInputFlavors } from "@/ui/TextInput/types";
import { createCampaign } from "@/api/campaigns";
import { getSessionToken } from "@/api/auth";

// Launch Sites: name a site and go straight to its (empty) dashboard. No template
// gallery — sites hold HTML pages built elsewhere (Kyle, Oct 7).
export const CreateSiteModal = ({ setIsOpen }: { setIsOpen: (isOpen: boolean) => void }) => {
  const [name, setName] = useState<string>("");
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();

  const handleCreate = async () => {
    setError("");
    if (!name.trim()) return setError("Give the site a name.");
    const response: any = await createCampaign({ token: getSessionToken() || "", name: name.trim(), type: "site" });
    if (!response?.id) return setError(response?.error || "The site couldn't be created. Try again.");
    setIsOpen(false);
    navigate(`/sites/${response.id}`);
  };

  return (
    <Modal title="Create a site" onClose={() => setIsOpen(false)} onSuccess={handleCreate}>
      <div className="flex flex-col gap-4">
        <div>
          <Title>What would you like to name this site?</Title>
          <TextInput
            placeholder="e.g. First Bank — October Event"
            value={name}
            onChange={(e) => setName(e.target.value)}
            flavor={TextInputFlavors.MODERN}
          />
        </div>
        {error && <Calout title={error} />}
      </div>
    </Modal>
  );
};
